export default function displayValidation(type) {
  console.log("NETRAA" + type)
  if(true) { //check configuration
    switch (type) {
      case "ok":
        localStorage.setItem('validationResponse', JSON.stringify({status: "OK", date: new Date()}))
        break;
      case "ko":
        localStorage.setItem('validationResponse', JSON.stringify({status: "KO", date: new Date()}))
        break;
      default:
        break;
    }
  }



}
